import React from 'react';
import { AppBar, Toolbar, Menu, MenuItem, Button, Divider } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HomeIcon from '@mui/icons-material/Home';
import { makeStyles } from '@mui/styles';

const Navbar1 = () => {
  const useStyles = makeStyles(theme => ({
    buttonStyle: {
      fontSize: '14px !important',
      color: 'azure !important',
      whiteSpace: 'nowrap',
      marginRight: 16,
      marginLeft: 16,
    }
  }));
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorElsnp, setAnchorElsnp] = React.useState(null);
  const [anchorElswm, setAnchorElswm] = React.useState(null);
  const [anchorElmncacts, setAnchorElmncacts] = React.useState(null);
  const [anchorEltna, setAnchorEltna] = React.useState(null);
  const open = Boolean(anchorEl);
  const openAU = Boolean(anchorEl1);
  const opensnp = Boolean(anchorElsnp);
  const openswm = Boolean(anchorElswm);
  const openmncacts = Boolean(anchorElmncacts);
  const opentna = Boolean(anchorEltna);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickAboutUs = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseAboutUs = () => {
    setAnchorEl1(null);
  };

  const handleClicksnp = (event) => {
    setAnchorElsnp(event.currentTarget);
  };

  const handleClosesnp = () => {
    setAnchorElsnp(null);
  };

  const handleClickswm = (event) => {
    setAnchorElswm(event.currentTarget);
  };

  const handleCloseswm = () => {
    setAnchorElswm(null);
  };

  const handleClickmncacts = (event) => {
    setAnchorElmncacts(event.currentTarget);

  };

  const handleClosemncacts = () => {
    setAnchorElmncacts(null);
  };

  const handleClicktna = (event) => {
    setAnchorEltna(event.currentTarget);
  };

  const handleClosetna = () => {
    setAnchorEltna(null);
  };

  return (
    <AppBar style={{ height: "45px", backgroundColor: "#0e7693", paddingLeft: '16px', paddingRight: "16px" }} position='static'>
      <Toolbar style={{ minHeight: "45px" }}>

        <Button
          className={classes.buttonStyle}
          id="home-button"
          aria-haspopup="true"
          component={Link}
          to="/"

        >
          <HomeIcon style={{ width: "30px", height: "30px" }} />
        </Button>
        <Button
          className={classes.buttonStyle}
          id="aboutus-button"
          aria-haspopup="false"
          component={Link}
          to="/digit-ui/citizen/aboutus"
        >
          About Us
        </Button>
        <Button
          component={Link}
          to='/digit-ui/citizen/notifications'
          className={classes.buttonStyle}
          id="snp-button"
          aria-controls={opensnp ? 'schemes' : undefined}
          aria-haspopup="true"
          aria-expanded={opensnp ? 'true' : undefined}
          onMouseOver={handleClicksnp}
        >
          Notifications/Orders
        </Button>
        <Button
          className={classes.buttonStyle}
          id="actnrules-button"
          aria-controls={open ? 'act' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onMouseOver={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Act & Rules
        </Button>

        <Button
          href='https://tcp.hp.gov.in/developmentPlan/8'
          className={classes.buttonStyle}
          id="swm-ngt-button"
          aria-controls={openswm ? 'solid' : undefined}
          aria-haspopup="true"
          aria-expanded={openswm ? 'true' : undefined}
          onMouseOver={handleClickswm}
        >
          Development Plan
        </Button>
        <Button
          component={Link}
          to='/digit-ui/citizen/faq'
          className={classes.buttonStyle}
          id="mncacts-rules-button"
          aria-controls={openmncacts ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openmncacts ? 'true' : undefined}
          onClick={handleClickmncacts}
        >
          FAQ
        </Button>
        <Button
          component={Link}
          to='/digit-ui/citizen/userguidemanual'
          className={classes.buttonStyle}
          id="tendnadvt-button"
          aria-controls={openmncacts ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={opentna ? 'true' : undefined}
          onClick={handleClicktna}
        >
          User Guide
        </Button>
        <Button
          className={classes.buttonStyle}
          id="contactus-button"
          aria-haspopup="true"
          component={Link}
          to='/digit-ui/citizen/contactus'
        >
          Contact Us
        </Button>
        <Menu
          sx={{
            width: { sm: 400, md: 600 },
            "& .MuiInputBase-root": {
              height: 80,
              whiteSpace: 'nowrap',
            },
            "& .MuiList-root": {
              width: 125,
              whiteSpace: 'nowrap',
              display: "Box",
              backgroundColor: "#0e7693",
              alignContent: "right"

            }

          }}
          id="act"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}

        >
          <MenuItem style={{ width: "80px", backgroundColor: "#0e7693" }}><NavLink to="/digit-ui/citizen/acts" underline="none" style={{ textDecoration: "none", color: 'white' }}>Acts</NavLink></MenuItem>
          <Divider style={{ color: "white" }} />
          <MenuItem style={{ width: "80px", backgroundColor: "#0e7693" }}><NavLink to="/digit-ui/citizen/rules" underline="none" style={{ textDecoration: "none", color: 'white' }}>Rules</NavLink></MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar1;
